import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/web.dom-collections.for-each.js";
import Gikam from 'gikam';
export var FromUtils = /*#__PURE__*/function () {
  function FromUtils() {
    _classCallCheck(this, FromUtils);
  }

  _createClass(FromUtils, null, [{
    key: "toggleFields",
    value:
    /**
     * @description 切换字段的显示隐藏
     * @static
     * @param {*} fields
     * @param {*} action
     * @param {*} form
     * @returns
     * @memberof FromUtils
     */
    function toggleFields(fields, action, form) {
      if (!Array.isArray(fields)) {
        Gikam.error("".concat(action, "Fields function param require Array"));
        return;
      }

      var viewModel = form.model.$refs.vm;
      fields.forEach(function (field) {
        var group = viewModel.$refs['group_' + field];

        if (group) {
          group[0].hide = action === 'show' ? false : true;
        }
      });
    }
  }]);

  return FromUtils;
}();